//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from 'axios'

export default {
    data() {
            return {
                page: 1,
                //comment:[]
                data: null,
                total: null,
                pageConut: null,
                pageNum: []
            }
        },
        methods: {
            changeContent(index) {
            	var self = this;
                axios.get('http://localhost:8008/comment', {
                        params: {
                            page:index+1 
                        }
                    })
                    .then(function(response) {
                        self.data = response.data.data;
                        console.log(self.data);
                        console.log(self);
                    })
                    .catch(function(error) {
                        console.log(error);
                    });
            },
            sendId(did){
            	console.log(did);
            }
        },
        mounted() {
            // this指向的问题
            var self = this;
            axios.get('http://localhost:8008/comment', {
                    params: {
                        page: this.page
                    }
                })
                .then(function(response) {
                    self.data = response.data.data;
                    self.total = response.data.num;
                    self.pageCount = Math.ceil(self.total / 10);
                    console.log(self.pageNum, self.pageCount, self.total);
                    for (var i = 1; i <= self.pageCount; i++) {
                        //console.log(i);
                        self.pageNum.push(i);
                    }
                    console.log(self.pageNum);
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        filters: {
            shortTitle(input) {
                if (input.length > 10) {
                    return input.slice(0, 10) + '...';
                } else {
                    return input
                }
            }
        },
        computed:{

        }
}



// WEBPACK FOOTER //
// ./src/views/db.vue